
import { useState, useEffect } from 'react';
import { CartProduct } from './types';
import { calculateDiscount } from '@/utils/promoCode/calculation';
import { useProductPricing } from '@/hooks/useProductPrices';

export const useCartDiscount = (
  promoCode: string,
  cartItems: CartProduct[]
) => {
  const [discount, setDiscount] = useState(0);
  const [promoEligibleItems, setPromoEligibleItems] = useState<number[]>([]);
  const { getProductPrice } = useProductPricing();

  useEffect(() => {
    const updateDiscount = async () => {
      try {
        if (promoCode && promoCode.trim() !== '' && cartItems.length > 0) {
          console.log('Calculating discount for promo code:', promoCode, 'cart items:', cartItems.length);
          
          // Pass the getProductPrice function to use current (sale) prices
          const { discount: calculatedDiscount, eligibleProductIds } = await calculateDiscount(
            promoCode, 
            cartItems,
            getProductPrice
          );
          console.log('Calculated discount result:', { calculatedDiscount, eligibleProductIds });
          
          // Always set the calculated discount, even if it's 0
          setDiscount(calculatedDiscount);
          setPromoEligibleItems(eligibleProductIds || []);
          
          if (calculatedDiscount > 0) {
            console.log('Applied discount:', calculatedDiscount);
          } else {
            console.log('No discount applied for promo code:', promoCode);
          }
        } else if (!promoCode || promoCode.trim() === '') {
          console.log('No promo code, resetting discount to 0');
          setDiscount(0);
          setPromoEligibleItems([]);
        }
      } catch (error) {
        console.error('Error updating discount:', error);
        setDiscount(0);
        setPromoEligibleItems([]);
      }
    };
    
    updateDiscount();
  }, [promoCode, cartItems.length]);

  return {
    discount,
    promoEligibleItems,
    setDiscount,
    setPromoEligibleItems
  };
};
